import React, { useState, useEffect } from 'react'
import * as helper from "../../utils/helper";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { Modal, Row, Col } from 'react-bootstrap';
import InputText from "../InputText";
import InputSelect from "../InputSelect";
import { logout } from "../../redux/actions/logoutAction";
import { loading } from "../../redux/actions/loadingAction";
import * as API from "../../utils/apis";

function ModalTestMethod({ show, close, save, mode, idEdit }) {
    const user = useSelector(state => state.login.result);

    const initialForm = {
        disease: "",
        testMethod_id: "",
        testMethod_name: "",
        testMethod_code: "",
        status: "",
        createDate: "",
        updateDate: "",

        checkShow: false
    };
    const initInvalidMsg = {
        disease: "",
        testMethod_name: "",
        testMethod_code: "",
        status: "",
    };
    const selectStatusList = [
        { value: 1, label: "ใช้งาน" },
        { value: 2, label: "ไม่ใช้งาน" },
    ];

    const initStatusSelectValue = [];
    const initDiseaseSelectValue = [];
    const selectDiseaseList = [];

    const dispatch = useDispatch();
    const history = useHistory();

    const [form, setForm] = useState(initialForm);
    const [invalid, setInvalid] = useState(initInvalidMsg);
    const [statusSelectValue, setStatusSelectValue] = useState(initStatusSelectValue);
    const [statusList, setStatusList] = useState(selectStatusList);
    const [diseaseSelectValue, setDiseaseSelectValue] = useState(initDiseaseSelectValue)
    const [diseaseList, setDiseaseList] = useState(selectDiseaseList)

    useEffect(async () => {
        if (mode === "add") {
            await setForm(initialForm)
            setStatusSelectValue([])
            setDiseaseSelectValue([])
        }
    }, [mode])

    useEffect(async () => {
        if (mode === "edit" && !form.checkShow) {
            await getTestMethodById(idEdit)
        }
    }, [mode, idEdit, show, form.testMethod_name, form.testMethod_code, form.status, form.disease])

    useEffect(async () => {
        await getDiseaseType()
    }, [])

    const addInvalid = (element, message) => {
        invalid[element] = message;
        setInvalid({ ...invalid });
    };

    const removeInvalid = (element) => {
        invalid[element] = "";
        setInvalid({ ...invalid });
    };

    const validate = () => {
        let validated = true;

        if (form.testMethod_name === "") {
            addInvalid("testMethod_name", "โปรดระบุวิธีการทดสอบ");
            validated = false;
        }

        if (form.status === "") {
            addInvalid("status", "กรุณาเลือกสถานะ");
            validated = false;
        }

        if (form.disease === "") {
            addInvalid("disease", "กรุณาเลือกชนิดโรค");
            validated = false;
        }

        if (form.testMethod_code === "") {
            addInvalid("testMethod_code", "โปรดระบุรหัส");
            validated = false;
        }

        return validated;
    };

    const handleClose = () => {
        close()
        setInvalid(initInvalidMsg)
        setForm(initialForm)
        setStatusSelectValue([])
        setDiseaseSelectValue([])
    }

    const toConfirm = async () => {
        if (validate()) {
            await save({ testMe: form, mode: mode });
            handleClose();
        }
    };

    const getDiseaseType = async () => {
        try {
            const response = await API.getDiseaseType();
            const data = await response.data;
            if (response.status === 200) {
                let diseaseArray = [];
                data.content.forEach(element => {
                    diseaseArray.push({
                        value: element.id, label: element.name,
                    });
                });
                setDiseaseList(diseaseArray);
            }
        } catch (error) {
            console.log(error)
        }
    }

    const getTestMethodById = async (id) => {
        let dataTme;
        try {
            const response = await API.getTestMethodById(id);
            const data = await response.data;
            if (response.status === 200) {
                dataTme = data;
            }
        } catch (error) {
            dispatch(loading(false))
            if (error.response && error.response.status === 401) {
                dispatch(logout({ history }))
            }
            console.log(error)
        }

        if (dataTme.statusId) {
            let statusSelect = await statusList.find(item => item.value === dataTme.statusId);
            setStatusSelectValue(statusSelect);
        }

        if (dataTme.diseaseTypeId) {
            let diseaseSelect = await diseaseList.find(item => item.value === dataTme.diseaseTypeId);
            setDiseaseSelectValue(diseaseSelect);
        }

        setForm({
            ...form,
            testMethod_id: dataTme.id,
            testMethod_name: dataTme.name,
            testMethod_code: dataTme.code,
            disease: dataTme.diseaseTypeId,
            status: dataTme.statusId,
            createDate: dataTme.createDate,
            createDate: dataTme.createDate,
            updateDate: dataTme.updateDate

        })
    }

    return (
        <Modal
            show={show}
            size="lg"
            onHide={() => { handleClose() }}
            centered
        >
            <Modal.Header closeButton className="pb-2 ">
                <Modal.Title className="mt-2">
                    <h5><strong>เพิ่มวิธีการทดสอบ</strong></h5>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-3">
                <div className="">
                    <ul className="nav nav-tabs" id="myTab" role="tablist">
                        <li className="nav-item tab">
                            <a className="nav-link active" id="data-tab" data-toggle="tab" href="#data" role="tab" aria-controls="data" aria-selected="true">ข้อมูลพื้นฐาน</a>
                        </li>
                        <li className={invalid.status ? "nav-item-invalid tab" : "nav-item tab"}>
                            <a className="nav-link" id="status-tab" data-toggle="tab" href="#status" role="tab" aria-controls="status" aria-selected="false">สถานะ</a>
                        </li>
                    </ul>
                    <div className="tab-content" id="myTabContent">
                        <div className="tab-pane fade show active card-tab" id="data" role="tabpanel" aria-labelledby="data-tab">
                            <Row>
                                <Col lg={6} md={6} sm={12} xs={12}>
                                    <InputText type="text" title="วิธีการทดสอบ" idName="testMethod_name" value={form.testMethod_name} star={false}
                                        placeholder="โปรดระบุ" classLabel="normal"
                                        handleChange={(value) => setForm({ ...form, testMethod_name: value, checkShow: true })}
                                        handleInvalid={() => removeInvalid("testMethod_name")}
                                        invalid={invalid.testMethod_name}
                                    />
                                </Col>

                                <Col lg={4} md={6} sm={12} xs={12}>
                                    <InputText type="text" title="รหัส" idName="testMethod_code" value={form.testMethod_code} star={false}
                                        placeholder="โปรดระบุ" classLabel="normal"
                                        handleChange={(value) => setForm({ ...form, testMethod_code: value, checkShow: true })}
                                        handleInvalid={() => removeInvalid("testMethod_code")}
                                        invalid={invalid.testMethod_code}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={6} md={6} sm={12} xs={12}>
                                    <InputSelect
                                        title="ชนิดโรค" star={false} placeholder="กรุณาเลือก" idName="title" classLabel="normal" selectValue={diseaseSelectValue}
                                        optionsList={diseaseList} handleSelectValue={(value) => setDiseaseSelectValue([{ value: value.value, label: value.label },])}
                                        handleChange={(value) => setForm({ ...form, disease: value.value, checkShow: true })}
                                        handleInvalid={() => removeInvalid("disease")}
                                        invalid={invalid.disease}
                                    />
                                </Col>
                            </Row>
                        </div>
                        <div className="tab-pane fade card-tab" id="status" role="tabpanel" aria-labelledby="status-tab">
                            <Row>
                                <Col lg={3} md={6} sm={12} xs={12}>
                                    <InputSelect
                                        title="สถานะ" star={false} placeholder="กรุณาเลือก" idName="title" classLabel="normal"
                                        selectValue={statusSelectValue} optionsList={statusList}
                                        handleSelectValue={(value) => setStatusSelectValue([{ value: value.value, label: value.label },])}
                                        handleChange={(value) => setForm({ ...form, status: value.value, checkShow: true })}
                                        handleInvalid={() => removeInvalid("status")} invalid={invalid.status}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={3} md={6} sm={12} xs={12}>
                                    <div className="d-flex align-items-center text-gray mb-0 font12 mt-3 ml-2">
                                        <p className="mr-4">วันที่บันทึกข้อมูล</p>
                                        <p>{form.createDate ? helper.momentDate(form.createDate, "th", "short") : '-'}</p>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={3} md={6} sm={12} xs={12}>
                                    <div className="d-flex align-items-center text-gray mb-0 font12 ml-2">
                                        <p className="mr-3" >วันที่ปรับปรุงข้อมูล</p>
                                        <p>{form.updateDate ? helper.momentDate(form.updateDate, "th", "short") : '-'}</p>
                                    </div>
                                </Col>

                            </Row>
                        </div>

                    </div>
                </div>
                <div className="mr-2 mt-3 mb-2">
                    <div className="text-right py-2">
                        <button className="btn btn-danger px-4 mr-2" onClick={() => handleClose()}>ยกเลิก</button>
                        <button className="btn btn-success px-4" onClick={() => toConfirm()} disabled={user?.userGroup.mupdate === "n" && mode === "edit"}>บันทึก</button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}
export default ModalTestMethod
